import React from 'react';
import Modal from 'react-awesome-modal';
import { useDispatch, useSelector } from 'react-redux';
import { DeleteAddress, CloseDialogConfirmDeleteAddress } from '../../store/actions';

function DialogConfirmDeleteAddress() {
    const dispatch = useDispatch();
    const wording = useSelector(({ language }) => language.wording);
    const open = useSelector(({ address }) => address.dialogConfirmDelete);

    return (
        <Modal
            visible={open}
            width='450'
            effect='fadeInUp'
            onClickAway={() => dispatch(CloseDialogConfirmDeleteAddress())}>
            <div className='m-20'>
                <div className='dialog-header'>
                    <h4 style={{ color: '#2d64cf' }}>{`${wording.usermenu.address.dialogConfirmDelete.title}`}</h4>
                </div>
                <div className='dialog-body mt-20 mb-20'>
                    <p style={{ fontSize: 16 }}>{wording.usermenu.address.dialogConfirmDelete.bodyMessage}</p>
                </div>
                <div className='dialog-action row'>
                    <div className='col-md-6'>
                        <button
                            style={{ width: '100%' }}
                            className='btn btn-md btn-dark'
                            onClick={() => {
                                dispatch(CloseDialogConfirmDeleteAddress());
                                dispatch(DeleteAddress());
                            }}>
                            {wording.usermenu.address.dialogConfirmDelete.delete}
                        </button>
                    </div>
                    <div className='col-md-6'>
                        <button
                            style={{ width: '100%' }}
                            className='btn btn-md btn-light-red'
                            onClick={() => dispatch(CloseDialogConfirmDeleteAddress())}>
                            {wording.usermenu.address.dialogConfirmDelete.cancel}
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
}

export default DialogConfirmDeleteAddress;
